<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h4> {{ $t('contract.financeSection') }} </h4>
      </v-col>
      <v-col cols="6" v-if="!form.isMultiCurrency">
        <vf-currency-input
          v-model="form.signedPriceCents"
          :currency="form.currencies[0]"
          :currencies="form.currencies"
          :label="$t('contract.signedPrice')"
          outlined
          @input="handlePriceChange"
          :error-messages="errorMessages(validationModel.form.signedPriceCents, 'signedPriceCents')"
          :disabled="!!form.currentPriceCents"
        />
      </v-col>
      <v-col cols="6" v-else>
        <div
          v-for="([currency, value]) in calculatePriceCents"
          :key="currency"
        >{{ value | formatCurrency({ key: currency, value: 1}) }}</div>
      </v-col>
      <v-col cols="6">
        <v-row
          v-for="(item, index) in form.currencies"
          :key="index"
          align="baseline"
        >
          <v-col cols="6">
            <v-autocomplete
              v-model="item.key"
              :items="currencies"
              :label="$t('contract.currencyCode')"
              outlined
              :hint="index ? '': $t('contract.currencyHint')"
              :persistent-hint="!index"
              :hide-details="!!index"
              item-value="code"
              item-text="code"
              @change="validationModel.form.currencies.$each[index].key.$touch()"
              :error-messages="errorMessages(validationModel.form.currencies.$each[index].key, 'key')"
            />
          </v-col>
          <template v-if="index > 0">
            <v-col cols="4">
              <v-text-field
                :label="$t('contract.currencyRatio')"
                v-model="item.value"
                outlined
                hide-details
                type="number"
              />
            </v-col>
            <v-col cols="2">
              <v-btn
                rounded
                color="error"
                fab
                x-small
                :disabled="!!calculatePriceCents.find(i => i[0] === item.key)"
                @click="$emit('remove', index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </template>
          <v-btn
            v-else
            rounded
            dark
            fab
            color="success"
            x-small
            @click="addCurrency"
          >
            <v-icon> mdi-plus </v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h5> {{ $t('contract.overallCap') }} </h5>
        <LiquidatedDamagesCapForm
          :contractCurrencies="currencies"
          :parts="form.parts"
          :errorsCents="errorMessages(validationModel.form.liquidatedDamagesCap.valueCents, 'valueCents')"
          :valueCents="form.liquidatedDamagesCap.valueCents"
          :valuePercent="form.liquidatedDamagesCap.valuePercent"
          :currency="form.liquidatedDamagesCap.currency"
          :isPercentMode="isCapPercentMode"
          @TOGGLE_PERCENT_MODE="toggleCapPercentMode"
          @CENTS_INPUT="handleCapCentsInput"
          @PERCENT_INPUT="handleCapPercentInput"
          @CURRENCY_INPUT="handleCapCurrencyInput"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FinancesSection',
  props: ['form', 'currencies', 'validationModel', 'prices', 'errorMessages', 'isMultiCurrency'],
  data () {
    return {
      isCapPercentMode: !!this.form.liquidatedDamagesCap.valuePercent
    }
  },
  computed: {
    calculatePriceCents () {
      return Object.entries(this.form.parts.reduce((acc, curr) => {
        acc[curr.currency] ? acc[curr.currency] += curr.signedPriceCents : acc[curr.currency] = curr.signedPriceCents
        return acc
      }, {}))
    }
  },
  created () {
    if (this.form.liquidatedDamagesCap.valuePercent) {
      this.form.liquidatedDamagesCap.valueCents = null
    }
  },
  methods: {
    addCurrency () {
      this.form.currencies.push({ key: '', value: 1 })
    },
    handlePriceChange () {
      this.validationModel.form.signedPriceCents.$touch()
      this.form.parts = this.form.parts.map(i => {
        return {
          ...i,
          signedPriceCents: this.form.signedPriceCents * (i.ratio / 100)
        }
      })
    },
    handleCapCentsInput (value) {
      this.form.liquidatedDamagesCap.valueCents = value
    },
    handleCapPercentInput (value) {
      this.form.liquidatedDamagesCap.valuePercent = value
    },
    handleCapCurrencyInput (value) {
      this.form.liquidatedDamagesCap.currency = value
    },
    toggleCapPercentMode () {
      this.isCapPercentMode = !this.isCapPercentMode
    }
  },
  watch: {
    calculatePriceCents (v) {
      if (v.length > 1) {
        const currencies = v.map(([currency]) => currency)
        const missingCurrencies = currencies.filter(i => !this.form.currencies.find(j => j.key === i))
        this.form.currencies.push(...missingCurrencies.map(i => ({ key: i, value: 1 })))
      }
    },
    'form.currencies': {
      deep: true,
      handler (v) {
        if (v.length >= 1 && this.form.parts && !this.form.isMultiCurrency) {
          this.form.parts = this.form.parts.map(part => ({ ...part, currency: v[0].key }))
        }
        this.$emit('calculate-percents')
      }
    },
    isCapPercentMode (v) {
      if (v) {
        this.form.liquidatedDamagesCap.valueCents = null
        this.form.liquidatedDamagesCap.valuePercent = 0
      } else {
        this.form.liquidatedDamagesCap.valueCents = 0
        this.form.liquidatedDamagesCap.valuePercent = null
      }
    }
  }
}
</script>
